(function () {
  'use strict';

  var INTERVAL_MS = 5000;

  function init() {
    var bar = document.querySelector('.announcement-bar');
    var items = document.querySelectorAll('.announcement-bar__item');
    if (!bar || items.length < 2) return; // only one message, nothing to rotate

    var index = 0;
    var timer = null;

    function show(newIndex) {
      items[index].classList.remove('is-active');
      index = (newIndex + items.length) % items.length;
      items[index].classList.add('is-active');
    }

    function startTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(function () { show(index + 1); }, INTERVAL_MS);
    }

    var prevBtn = bar.querySelector('.announcement-bar__nav--prev');
    var nextBtn = bar.querySelector('.announcement-bar__nav--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        show(index - 1);
        startTimer();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        show(index + 1);
        startTimer();
      });
    }

    startTimer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();